import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import { useSidebar } from '../../providers/SidebarProvider';
import { useTool } from '../../providers/ToolProvider';
import { CategoryContext } from '../../providers/CategoryProvider';

/**
 * SidebarのAccordionの初期状態の開閉状態を管理する
 */
export default function useInitialSidebarAccordion() {
  const { categories } = useContext(CategoryContext);
  const router = useRouter();
  const isToolPath = router.pathname.indexOf('/tools') !== -1;
  const isToolCatPath = router.pathname.indexOf('/tools/categories') !== -1;
  const currentToolId = router.query.id;
  const { tools, isToolsLoading } = useTool();
  const { setActiveIndex } = useSidebar();

  useEffect(() => {
    if (isToolsLoading || isToolsLoading === undefined || !isToolPath || currentToolId === null) {
      return;
    }

    const currentToolCategoryId =
      currentToolId !== null
        ? tools.reduce((prev, tool) => {
            const category = tool.categories.length > 0 ? tool.categories[0] : null;
            return tool.id === Number(currentToolId) && category ? category.id : prev;
          }, null)
        : null;

    const defaultMenuIndex = categories.findIndex((category) => category.id === currentToolCategoryId);

    if (!isToolCatPath && defaultMenuIndex > -1) {
      setActiveIndex(defaultMenuIndex);
    }

    // toolがロードされたかどうかが分かれば十分なので、isToolsLoadingだけを第二引数に設定
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isToolsLoading]);
}
